export const REMOTE_URL = "";
export const GET_DEPT_URL =
  "/api/v1/regions/countries_with_communication_companies";
export const ADD_DEPT_URL = "/api/v1/communication_companies/create";
export const UPD_DEPT_URL = "/api/v1/communication_companies/update";
